<template>
 <div :class="windowClass">
        <v-row no-gutters >
            <v-col cols="12">
                <v-toolbar>
                  <!-- <span style="width: 100px; margin-right: 6px;">
                            <v-autocomplete
                               v-model="customer_type"
                               :items="['ALL', 'CASH', 'CREDIT']"
                               label="Type"
                                dense
                             hide-details
                               single-line
                               outlined
                            />
                        </span> -->
                        <v-autocomplete 
                            :items="FilterCustomers"
                            v-model="customer"
                           @change="account={}, Transactions=[],  getTotal(), getTransactions()"
                            dense
                             hide-details
                               single-line
                            item-text="firstname"
                            item-value="id"
                            return-object=""
                            outlined
                            label="Customer's Search"
                        />
                      
                </v-toolbar>
            </v-col>
           
             <v-col sm="12" class="pa-1"  v-if="customer.id > 0">
                 <v-card>
                        <v-card-text class="mt-10">
                          <v-row no-gutters>
                          <v-col cols="6" class="pa-1">
                            <table  class="va-table" style="width: 100%">
                              <tr>
                                  <td width="100px">NAME:</td>
                                  <td> {{customer.firstname}}</td>
                              </tr>
                              <tr>
                                  <td width="120px">ADDRESS:</td>
                                  <td> {{customer.address}}</td>
                              </tr>
                           
                              <tr>
                                  <td width="120px">REGISTERED:</td>
                                  <td> {{$moment(customer.created).format('MMM DD, YYYY')}}</td>
                              </tr>
                            </table>
                            
                          </v-col>

                          <v-col cols="6" class="pa-1">
                            <table  class="va-table" style="width: 100%">
                             
                              <tr>
                                  <td width="120px">STATUS:</td>
                                  <td> {{customer.status.toUpperCase()}}</td>
                              </tr>
                              <tr>
                                  <td width="120px">CREDIT:</td>
                                  <td> {{customer.credit?customer.credit.toUpperCase():'N/A'}}</td>
                              </tr>
                              <tr>
                                  <td width="120px">EVAT:</td>
                                  <td> {{customer.evat?customer.evat:'N/A'}}</td>
                              </tr>
                             
                            </table>
                            
                          </v-col>
                          <v-col cols="12">
                            <v-divider class="mt-4 mb-4"/>
                                  <v-row  no-gutters class="mt-5 body-2 text-center">
                                      <v-col md="4" class="pa-1">
                                          <span class="va-underline">TOTAL CREDITS</span><br /> 
                                          <span  class="text-h6">{{$money(COLLECTIBLE_AMOUNT)}}</span>
                                      </v-col>  
                                      <v-col md="4" class="pa-1">
                                        <span class="va-underline">TOTAL PAYMENTS</span> <br /> 
                                          <span  class="text-h6">{{$money(PAYMENT_AMOUNT)}}</span>
                                      </v-col>
                                      <v-col md="4" class="pa-1">
                                          <span class="va-underline">COLLECTIBLE BALANCE</span><br /> 
                                          <span class="text-h4">{{$money(TOTAL_CURRENT_COLLECTIBLE)}}</span>
                                      </v-col>
                                  </v-row>
                          </v-col>
                        </v-row>
                          <v-divider class="mt-4 mb-4"/>
                             <v-row class="ma-1">
                              <v-icon left color="secondary" @click="lock = !lock">mdi-{{lock?'lock':'lock-open-variant'}}</v-icon>
                                <v-spacer/>
                                <v-card class="elevation-0" width="220"> 
                                  <v-menu
                                  ref="menu"
                                  v-model="datemenu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="600px"
                              >
                                  <template v-slot:activator="{ on }">
                                  <v-text-field
                                      :value="selected_date +' - '+selected_date2"
                                      label="select date range"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      dense
                                      single-line
                                      class="mr-2 sm-width"
                                      hide-details
                                      v-on="on"
                                  ></v-text-field>
                                  </template>
                                  <v-date-picker class="ma-1" v-model="selected_date" no-title scrollable @input="Transactions=[]" />
                                   <v-date-picker class="ma-1" v-model="selected_date2" no-title scrollable @input="datemenu = false, Transactions=[], getTransactions()" />
                                 
                              </v-menu>
                                </v-card>
                    
                            </v-row>
                              <v-divider />
                              <v-row>
                                <v-col cols="6">
                                  <v-toolbar dense elevation="1">
                                  
                                    Credits History
                                    <v-spacer/>
                                    <v-btn x-small color="primary" @click="showform=true, state='new', trans_type='Collectible'" title="add">
                                    <v-icon left small >mdi-file-document-plus</v-icon>
                                    ADD COLLECTIBLES
                                  </v-btn>
                                  </v-toolbar>
                                 
                                <table class="va-table-border-bot">
                                    <tr>
                                      <th class="text-left pa-1">TYPE</th>
                                      <th class="text-left pa-1">DATE</th>
                                      <th class="text-left pa-1">STATUS</th>
                                      <th class="text-right pa-1">AMOUNT</th>
                                    </tr>
                                      <tr v-for="(item,index) in getFilteredTransactions('Collectible')" :key="index" :class="type[item.type]">
                                          <!-- <td>
                                              <v-icon small color="error" @click="transaction = item,confirm=true" v-if="!lock">mdi-delete</v-icon> 
                                          {{item.id}}
                                          </td> -->
                                          <td>
                                            <!-- <v-icon small color="error" @click="transaction = item,confirm=true" v-if="!lock">mdi-delete</v-icon>  -->
                                            {{item.remarks}}</td>
                                          <!-- <td>{{ type[item.type] }}</td> -->
                                          <td>{{ item.trans_date | moment("lll") }} </td>
                                          <!-- <td>{{ item.reference }} </td> -->
                                          <td><v-chip small color="success" class="mt-1 mb-1">{{ item.status }} </v-chip> </td>
                                          <td class="text-right">{{ $money(item.amount) }} </td>
                                      </tr>
                                      <tr>
                                         <td colspan="4"  class="text-right"> TOTAL CREDITS: {{$money(COLLECTIBLE_AMOUNT)}}</td>
                                      </tr>
                                </table>
                               
                                </v-col>
                                <v-col cols="6">
                                  <v-toolbar dense elevation="1">
                                  
                                    Payments History
                                    <v-spacer/>
                                    <v-btn x-small color="secondary" @click="showform=true, state='new', trans_type='Payment'" title="add">
                                    <v-icon left small >mdi-file-document-plus</v-icon>
                                    ADD PAYMENT
                                  </v-btn>
                                  </v-toolbar>

                                  <table class="va-table-border-bot">
                                    <tr>
                                      <th class="text-left pa-1">TYPE</th>
                                      <th class="text-left pa-1">DATE</th>
                                      <th class="text-left pa-1">STATUS</th>
                                      <th class="text-right pa-1">AMOUNT</th>
                                    </tr>
                                      <tr v-for="(item,index) in getFilteredTransactions('Payment')" :key="index" :class="type[item.type]">
                                          <!-- <td>
                                              <v-icon small color="error" @click="transaction = item,confirm=true" v-if="!lock">mdi-delete</v-icon> 
                                          {{item.id}}
                                          </td> -->
                                          <td>
                                            <v-icon small color="error" @click="transaction = item,confirm=true" v-if="!lock">mdi-delete</v-icon> 
                                            {{item.remarks}}</td>
                                          <!-- <td>{{ type[item.type] }}</td> -->
                                          <td>{{ item.trans_date | moment("lll") }} </td>
                                          <!-- <td>{{ item.reference }} </td> -->
                                          <td><v-chip small color="success" class="mt-1 mb-1">{{ item.status }} </v-chip> </td>
                                          <td class="text-right">{{ $money(item.amount) }} </td>
                                      </tr>
                                      <tr>
                                         <td colspan="4"  class="text-right"> TOTAL PAYMENTS: {{$money(PAYMENT_AMOUNT)}}</td>
                                      </tr>
                                </table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                   
                    </v-card>
            </v-col>
        </v-row>

    <v-row  no-gutters class="mt-10 body-2 text-center">
        <v-col md="4" class="pa-1">
            <span class="va-underline">TOTAL CREDITS</span><br /> 
            <span  class="text-h6">{{$money(COLLECTIBLE_AMOUNT)}}</span>
        </v-col>  
        <v-col md="4" class="pa-1">
           <span class="va-underline">TOTAL PAYMENTS</span> <br /> 
            <span  class="text-h6">{{$money(PAYMENT_AMOUNT)}}</span>
        </v-col>
        <v-col md="4" class="pa-1">
            <span class="va-underline">COLLECTIBLE BALANCE</span><br /> 
            <span class="text-h4">{{$money(TOTAL_CURRENT_COLLECTIBLE)}}</span>
        </v-col>
    </v-row>


    <va-payable-form :show="showform" :account="customer" :trans_type="trans_type" :account_type="3" @DialogEvent="formEvent"/>
    <va-confirm :show="confirm" cancelbtn="No" okbtn="Delete" text="Would you like to delete this transaction?" @DialogEvent="cEvent"/>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        lock: true,
        view: 'All',
        customer_type: 'CREDIT',
        confirm: false,
        trans_type:'',
        showform: false,
        search:'',
        datemenu: false,
        datemenu2: false,
        selected_date:'',
        selected_date2:'',
        state:'new',
        Customers:[],
        customer:{},
        account: {},
        transaction:{},
        Transactions:[],
        headers:[
           {text: 'ID', value: 'id', sortable: false},
            {text: 'Transaction', value: 'remarks'},
            {text: 'Type', value: 'type'},
            {text: 'Date', value: 'trans_date'},
            {text: 'Ref ID', value: 'reference'},
            {text: 'Status', value: 'status'},
            {text: 'Amount', value: 'amount', align: "right"},
        ],
        type: ['','collectible','payable', 'payout', 'payment', 'sc payment', 'tf payment']
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date=this.$moment('2019-01-01').format('YYYY-MM-DD')
          this.selected_date2=this.$moment().format('YYYY-MM-DD')
          this.getCustomers()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      FilterCustomers() {
        if(this.customer_type=='ALL') {
          return this.Customers
        }

        var data = this.Customers.reduce((res,item)=>{
            if(this.customer_type == 'CASH') {
              if(item.credit != 'enabled') {
                res.push(item)
              }
            } else {
              if(item.credit == 'enabled') {
                res.push(item)
              }
            }
            return res
        },[])
        return data
      },
      PAYMENT_AMOUNT() {
          var arr = this.Transactions
           let total = arr.reduce((a, o) => o.type>=4?a += this.$IsNum(o.amount):a+=0, 0)
           return total
      },
       SALES_AMOUNT() {
          var arr = this.Transactions
           let total = arr.reduce((a, o) => o.type==1?a += this.$IsNum(o.amount):a+=0, 0)
           return total
      },
      COLLECTIBLE_AMOUNT() {
          var arr = this.Transactions
           let total = arr.reduce((a, o) => o.type==1?a += this.$IsNum(o.amount):a+=0, 0)
           return total
      },
      COLLECTIBLES() {
          return this.SALES_AMOUNT - this.PAYMENT_AMOUNT
      },
      TOTAL_CURRENT_COLLECTIBLE() {
        return this.$IsNum(this.account.collectible) - this.$IsNum(this.account.payout)
      },
      FILTEREDTRANSACTIONS(){
       
        if(this.view == 'Collectible') {
                let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 1) {
                          res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(this.view == 'Payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 4) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(this.view == 'SC payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 5) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(this.view == 'TF payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 6) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           }  else {
               return  this.Transactions
           }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      cEvent(data){
        this.confirm = false
        if('ok' == data) {
          this.deleteTransaction()
        }
      },
      formEvent(data){
        console.log(data)
        this.showform =false
        this.getTransactions()
        this.getTotal()
      },
      getFilteredTransactions(view){
        if(view == 'Collectible') {
                let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 1) {
                          res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(view == 'Payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 4) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(view == 'SC payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 5) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           } else if(view == 'TF payment') {
                 let arrTrans =  this.Transactions.reduce((res, item) =>{
                    if(item.type == 6) {
                        res.push(item)
                    }
                    return res
                }, [])
                return arrTrans
           }  else {
               return  this.Transactions
           }
      },
      deleteTransaction(){
           this.$http.post("transaction/delete", this.transaction).then(response => {
              response.data.status?this.VA_ALERT('success', response.data.message):this.VA_ALERT('error', response.data.message)
              this.getTransactions()
         }).catch(e => {
           console.log(e.data)
         })
      },
      getTotal(){
        this.$http.post("transaction/query_total", {account: this.customer.id, account_type: 3}).then(response => {
              response.data.data != null?this.account = response.data.data:this.account={}
              console.log(this.account)
         }).catch(e => {
           console.log(e.data)
         })
     },
       getTransactions(){
        this.$http.post("transaction/query", {account: this.customer.id, account_type: 3, start_date: this.selected_date, end_date: this.selected_date2}).then(response => {
              response.data.data != null?this.Transactions = response.data.data:this.Transactions=[]
         }).catch(e => {
           console.log(e.data)
         })
     },
       getCustomers() {
         this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.Customers = response.data.data:this.Customers=[]
          }).catch(e => {
           console.log(e.data)
         })
       }
     }
  }
</script>
<style>
  .payable {
    
  }
  .collectible {
    color: #19365A;
  }
  .payout, .payment {
    color: #5cb860;
  }
</style>
